/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Ref } from 'preact/hooks';
import { cancelEvent } from '../../utils/UNSAFE_visUtils';
import {
  createKbPanDownEvent,
  createKbPanEndEvent,
  createKbPanStartEvent,
  createKbPanUpEvent,
  createKbZoomInEvent,
  createKbZoomOutEvent
} from '../utils/keyboardUtils';

type UseTimeComponentKeyboardOptions = {
  visRef: Ref<HTMLDivElement>;
  isDisabled?: boolean;
};

/**
 * Hook that handles various Time Component keyboard gestures.
 */
const useTimeComponentKeyboard = ({
  visRef,
  isDisabled = false
}: UseTimeComponentKeyboardOptions) => {
  const onKeyDown = (event: KeyboardEvent) => {
    const key = event.key;
    switch (key) {
      case '=':
      case '+': {
        const e = createKbZoomInEvent();
        visRef.current?.dispatchEvent(e);
        cancelEvent(event);
        break;
      }
      case '-':
      case '_': {
        const e = createKbZoomOutEvent();
        visRef.current?.dispatchEvent(e);
        cancelEvent(event);
        break;
      }
      case 'PageUp': {
        const e = event.shiftKey ? createKbPanStartEvent() : createKbPanUpEvent();
        visRef.current?.dispatchEvent(e);
        cancelEvent(event);
        break;
      }
      case 'PageDown': {
        const e = event.shiftKey ? createKbPanEndEvent() : createKbPanDownEvent();
        visRef.current?.dispatchEvent(e);
        cancelEvent(event);
        break;
      }
    }
  };

  return isDisabled ? {} : { onKeyDown };
};

export { useTimeComponentKeyboard };
